import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'gtw-gold-sync-cron-help-dialog',
  templateUrl: './gold-sync-cron-help-dialog.component.html',
  styleUrls: ['./gold-sync-cron-help-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GoldSyncCronHelpDialogComponent {
  constructor(private dialogRef: MatDialogRef<GoldSyncCronHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
